import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ArrowRightIcon = createIcon({
  displayName: 'ArrowRight',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M19,12h-14"></path>
        <path d="M14,17l5,-5"></path>
        <path d="M14,7l5,5"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const ArrowRight: FC<IconProps> = (props) => {
  return <CustomIcon as={ArrowRightIcon} {...props} />
}

export default memo(ArrowRight)
